import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Col } from "shards-react";

import SidebarMainNavbarAdmin from "./SidebarMainNavbarAdmin";
import SidebarSearch from "./SidebarSearch";
import SidebarNavItemsAdmin from "./SidebarNavItemsAdmin";

import { StoreAdmin } from "../../../flux";

class MainSidebarAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuVisible: false,
      sidebarNavItems: StoreAdmin.getSidebarItems()
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    StoreAdmin.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    StoreAdmin.removeChangeListener(this.onChange);
  }

  onChange() {
    this.setState({
      ...this.state,
      menuVisible: StoreAdmin.getMenuState(),
      sidebarNavItems: StoreAdmin.getSidebarItems()
    });
  }

  render() {
    const classes = classNames(
      "main-sidebar",
      "px-0",
      "col-12",
      this.state.menuVisible && "open"
    );

    return (
      <Col
        tag="aside"
        className={classes}
        lg={{ size: 2 }}
        md={{ size: 3 }}
      >
        <SidebarMainNavbarAdmin hideLogoText={this.props.hideLogoText} />
        <SidebarSearch />
        <SidebarNavItemsAdmin />
      </Col>
    );
  }
}

MainSidebarAdmin.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool
};

MainSidebarAdmin.defaultProps = {
  hideLogoText: false
};

export default MainSidebarAdmin;
